import { render, staticRenderFns } from "./info_pc.vue?vue&type=template&id=5ab49638&scoped=true&"
import script from "./info_pc.vue?vue&type=script&lang=js&"
export * from "./info_pc.vue?vue&type=script&lang=js&"
import style0 from "./info_pc.vue?vue&type=style&index=0&id=5ab49638&lang=less&scoped=true&"
import style1 from "./info_pc.vue?vue&type=style&index=1&id=5ab49638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab49638",
  null
  
)

export default component.exports